// extracted by mini-css-extract-plugin
export var resizer = "_fc-0";